import styled from '@emotion/styled';
import { svgIconClasses } from '@mui/material/SvgIcon';

export const StyledContactFormHeader = styled.h2`
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 44px;
    margin: 0;
    color: ${(props) => props.theme.colorsUnifications.gunmetal[100]};
`;

export const StyledContactDirectly = styled.div`
    height: 100%;
    background-color: ${(props) => props.theme.colorsUnifications.azure[100]};
    padding: 24px 16px;

    ${StyledContactFormHeader} {
        color: #fff;
        margin-bottom: 24px;

        ${(props) => props.theme.media.mdAndUp} {
            margin-bottom: 36px;
        }
    }

    ${(props) => props.theme.media.mdAndUp} {
        padding: 36px;
        border-radius: 0px 12px 12px 0px;
    }
`;

export const StyledContactRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: 48px;
`;

export const StyledContactIcon = styled.div`
    align-self: flex-start;
    display: flex;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.08);
    padding: 16px;

    .${svgIconClasses.root} {
        color: #fff;
        width: 16px;
        height: 16px;
    }
`;

export const StyledRequestCallFormContainer = styled.div`
    background-color: #fff;
    padding: 24px 16px;
    color: ${(props) => props.theme.colorsUnifications.gunmetal[100]};

    ${(props) => props.theme.media.mdAndUp} {
        border-radius: 12px 0px 0px 12px;
        padding: 36px;
    }
`;
